import React, { Component } from 'react';
import Table from 'rc-table';
import Checkbox from 'rc-checkbox';
import EstadosDropdown from './EstadosDropdown';
import ProcesosDropdown from './ProcesosDropdown';
import CambiarEstadoDropdown from './CambiarEstadoDropdown';
import ExportarDropdown from './ExportarDropdown';
import EstadoInfoDropdown from './EstadoInfoDropdown';
import TipoPlasticoDropdown from './TipoPlasticoDropdown';
import TipoIcon from './TipoIcon';
import 'rc-table/assets/index.css';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';

const ParentCheckBox = ({ checked, clickFn }) => {

    const cssClass = "ParentCheckboxContainer default-checkbox" + (checked ? "" : " Disabled");

    return (
        <div className={cssClass} >
            <InputChecked name={name} checked={checked} />
            <label className="label-primary" htmlFor="parent-check" onClick={() => clickFn()}></label>
        </div>
    );
}

const Alerta = (props) => {
    if (props.mostrarError) {
        return <GenericAlert message="La busqueda encontró más de 200 productos. Agregue filtros para disminuir la cantidad." type="warning" />;
    } else {
        return null;
    }
}

const InputChecked = ({ name, checked }) => {

    const checkValue = checked ? "on" : "off";

    if (checked)
        return <input type="checkbox" id={name} name={name} value={checkValue} checked={checked} />

    return <input type="checkbox" id={name} name={name} value={checkValue} />
}

const ChildCheckBox = ({ name, checked, clickFn }) => {

    const cssClass = "ChildCheckbox default-checkbox" + (checked ? "" : " Disabled");

    return (
        <div className={cssClass}>
            <InputChecked name={name} checked={checked} />
            <label className="label-primary" htmlFor={name} onClick={() => clickFn()}></label>
        </div>
    );
}

class DeliveryTable extends Component {

    componentDidMount() {
        this.props.getDatosDelivery(this.props.currentScope);
    }

    render() {

        const { data, filterByFechaProceso, toggleCheckTipo, cambiarRangoPagina } = this.props;

        const {
            isFetching,
            parentChecked,
            filteredData,
            tarjetaChecked,
            pinChecked,
            estados,
            siguientes,
            tiposPlastico,
            fechasProceso,
            functions,
            sucursalUsuario,
            perfilUsuario
        } = data;

        if (isFetching || data.data === null || functions.length === 0 || sucursalUsuario == null || perfilUsuario === 0)
            return null;

        // Convertir funciones a un array.
        let checkedData = {};
        let tableData = null;
        let permisoVerSucursal;
        let permisoVerBanco;

        if (filteredData !== null && filteredData !== undefined) {
            const permisosUsuarioDelivery = functions.map(f => f.Codigo_Funcion.toLowerCase());
            checkedData = filteredData.filter(t => t.checked);
            tableData = filteredData;

            for (var i = 0; i < tableData.length; i++) {
                let sucDesc = this.props.data.cuentasDelivery.find(x => x.Codigo == tableData[i].sucursal);
                tableData[i].sucDesc = tableData[i].sucursal + ' - ' + sucDesc.Descripcion;
            }



            // Permisos
            permisoVerSucursal = permisosUsuarioDelivery.indexOf("deliveryversuc") != -1;
            permisoVerBanco = permisosUsuarioDelivery.indexOf("deliveryverbanco") != -1;

            // El usuario no tiene permisos para ver banco ni sucursal. Mostrar una advertencia.
            if (!permisoVerBanco && !permisoVerSucursal)
                return (
                    <div className="DeliveryTarjetasContainer">
                        <div className="DeliveryTitleContainer" >
                            <h1 className="DeliveryTitle">Delivery de tarjetas</h1>
                        </div>

                        <div className="DeliverySearchContainer InlineElement">
                            <p>Esta cuenta no tiene plásticos o su perfil no tiene permisos para verlos.</p>
                        </div>
                    </div>
                );

            // El usuario tiene permisos para ver sucursal (E.D no tiene permisos para ver banco). Filtrar plásticos y mostrar solo los de sucursal.
            if (permisoVerSucursal && !permisoVerBanco) {
                tableData = tableData.filter(p => p.sucursal == sucursalUsuario.Id);
            }

        }
        const columns = [
            {
                title: <ParentCheckBox clickFn={() => this.props.toggleCheckAll()} checked={parentChecked} />,
                dataIndex: 'checked',
                key: 'checked',
                render: (checked, row) => <ChildCheckBox name={"check-" + row.id} clickFn={() => this.props.toggleCheckedRow(row)} checked={row.checked} />
            },
            {
                title: 'NOMBRE',
                dataIndex: 'nombre',
                key: 'nombre',
                render: (text, row) => <p>{text}</p>
            },
            {
                title: 'TIPO',
                dataIndex: 'tipo',
                key: 'tipo',
                render: (text) => <TipoIcon tipo={text} />
            },
            {
                title: 'PRODUCTO',
                dataIndex: 'producto',
                key: 'producto',
                render: (text, row) => <p>N º {text}</p>
            },
            {
                title: 'CUENTA',
                dataIndex: 'NumeroCuenta',
                key: 'NumeroCuenta',
                render: (text, row) => <p>{text}</p>
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'sucDesc',
                key: 'sucDesc',
                render: (text, row) => <p>{text}</p>
            },
            {
                title: 'LOGIN',
                dataIndex: 'login',
                key: 'login',
                render: (text, row) => <p>{text}</p>
            },
            {
                title: <span></span>,
                dataIndex: 'estado',
                key: 'estado',
                render: (text, row) => <EstadoInfoDropdown text={text} row={row} estados={estados} siguientes={siguientes} />
            }
        ];

        if (this.props.data.loading) {
            return <div className="loading"> Loading &#8230;</div>;
        }

        let tiposProductosSeleccionados = [];
        for (var i = 0; i < this.props.data.tiposChecked.length; i++) {
            tiposProductosSeleccionados.push(this.props.data.tiposChecked[i].Id);
        }

        return (
            <div className="DeliveryTarjetasContainer">

                <div className="DeliveryTitleContainer" >
                    <h1 className="DeliveryTitle">Delivery de tarjetas</h1>
                </div>

                <Alerta mostrarError={this.props.data.datosExcedentes} />

                <div className="DeliverySearchContainer InlineElement">

                    <span className="InlineElement CambiarEstadoButton">
                        <CambiarEstadoDropdown
                            active={checkedData.length}
                            data={checkedData}
                            cambiarEstadoFn={this.props.cambiarEstadoProductos}
                            estados={estados}
                            siguientes={siguientes}
                            tiposPlastico={data.tiposPlastico}
                        />
                    </span>

                    <span className="InlineElement TipoPlasticoDropdownContainer">
                        <TipoPlasticoDropdown opciones={this.props.data.tiposPlastico} seleccionados={tiposProductosSeleccionados} selectFn={toggleCheckTipo} />
                    </span>

                    <span className="InlineElement SearchBoxContainer">
                        <input className="form-control SearchBox" placeholder="Nombre, Apellido, nº ó Sucursal" onChange={(e) => this.props.searchInTable(e.target.value, this.props.data)} />
                    </span>

                    <span className="InlineElement EstadosDropdownContainer">
                        <p>Estados</p>
                        <EstadosDropdown items={estados} changeFn={(value) => this.props.filterByEstado(value)} selectedValue={null} className="InlineElement" />
                    </span>

                    <span className="InlineElement">
                        <p className="ProcesosDropdownText">N&uacute;mero de proceso</p>
                        <ProcesosDropdown procesos={fechasProceso} filtrarFn={filterByFechaProceso} cambiarRangoPagina={cambiarRangoPagina} rangoIndex={data.rangoIndex} />
                    </span>

                    <span className="delivery-boton-buscar-span">
                        <button className="btn btn-cta delivery-boton-buscar" type="button" id="buttonBusquedaCliente" onClick={(e) => this.props.RealziarBusquedaProductoFiltrada(this.props.data)} >
                            <span className="ti-search" aria-hidden="true"></span>
                        </button>
                    </span>
                </div>

                {tableData != null && tableData != undefined ?
                    <div>
                        <Table
                            columns={columns}
                            data={tableData}
                            rowKey={record => record.key}
                            defaultExpandAllRows={true}
                            expandIconAsCell={false}
                            expandRowByClick={true}
                            emptyText="No existen tarjetas para buscar."
                        />
                    </div>
                    : null}
            </div>
        );
    }
}

export default DeliveryTable;